module.exports = __webpack_public_path__ + "static/img/24.d07498e1.png";